import React from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';
import { computeResourceDiscoveryApiRef } from '../../api';
import { KubernetesContextProvider } from './KubernetesContext';
import { Kubernetes } from './Kubernetes';
import { useEntity } from '@backstage/plugin-catalog-react';
import { CRDKubernetesConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';
import { Alert } from '@mui/material';

type KubernetesWithProvidersProps = {
  projectCode: string;
  kubernetesConfigs: CRDKubernetesConfig[] | undefined;
};

export const KubernetesWithProviders: React.FC<
  KubernetesWithProvidersProps
> = ({ projectCode, kubernetesConfigs }) => {
  const { entity } = useEntity<Entity>();
  const api = useApi(computeResourceDiscoveryApiRef);

  if (!kubernetesConfigs || kubernetesConfigs.length === 0) {
    return (
      <Alert severity="warning" sx={{ my: 2 }}>
        Kubernetes configuration not found for project code {projectCode}
      </Alert>
    );
  }

  return (
    <KubernetesContextProvider
      api={api}
      kubernetesConfigs={kubernetesConfigs}
      projectCode={projectCode}
    >
      <Kubernetes entity={entity} />
    </KubernetesContextProvider>
  );
};
